export default __webpack_public_path__ + "static/media/entertainment.a611097a.png";